// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1389":"45846201","5660":"7c8a98ea","6698":"71e3ef40"}[chunkId] + ".chunk.css";
};